<script lang="ts">
    import { Container, Row } from "sveltestrap";
    import BrowserUses from "./BrowserUses.svelte";
    import ChartBookmark from "./ChartBookmark.svelte";
    import LiveProducts from "./LiveProducts.svelte";
    import MarketingExpenses from "./MarketingExpenses.svelte";
    import MonthlySales from "./MonthlySales.svelte";
    import ProductChart from "./ProductChart.svelte";
    import ProjectChart from "./ProjectChart.svelte";
    import Salechart from "./Salechart.svelte";
    import TotalEarning from "./TotalEarning.svelte";
    import Turnover from "./Turnover.svelte";
    import Uses from "./Uses.svelte";
    import { onMount } from "svelte";
    import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
    let ispreloader: boolean = false;
    onMount(() => {
        setTimeout(() => {
            ispreloader = true;
        }, 1000);
    });
</script>
{#if !ispreloader }
  <PreLodaer />
{/if}
<ChartBookmark />
<Container fluid class="chart-widget">
    <Row>
        <Salechart />
        <ProjectChart />
        <ProductChart />
    </Row>
    <Row>
        <MarketingExpenses />
        <TotalEarning />
    </Row>
    <Row>
        <LiveProducts />
        <Turnover />
        <MonthlySales />
        <Uses />
    </Row>
    <Row>
        <BrowserUses />
    </Row>
</Container>
